import { render, staticRenderFns } from "./TradeInStepsSection.vue?vue&type=template&id=f0c97af4"
import script from "./TradeInStepsSection.vue?vue&type=script&lang=js"
export * from "./TradeInStepsSection.vue?vue&type=script&lang=js"
import style0 from "./TradeInStepsSection.vue?vue&type=style&index=0&id=f0c97af4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports